import {useQuery} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    GetAccountEnrichment_accountEnrichment as AccountEnrichment,
    GetAccountEnrichment as GetAccountEnrichmentQuery,
    GetAccountEnrichmentVariables as GetAccountEnrichmentQueryVariables,
} from 'nutshell-graphql-types';

import GET_ACCOUNT_ENRICHMENT from './../queries/get-account-enrichment.graphql';

export function useGetAccountEnrichment(accountId: string): {
    accountEnrichment: AccountEnrichment[] | null | undefined;
    isLoading: boolean;
    error: string | null | undefined;
} {
    const {data, error, loading} = useQuery<
        GetAccountEnrichmentQuery,
        GetAccountEnrichmentQueryVariables
    >(GET_ACCOUNT_ENRICHMENT, {
        variables: {accountId},
    });

    return {
        accountEnrichment: data ? data.accountEnrichment : undefined,
        isLoading: loading,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
    };
}
